import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thead-form',
  templateUrl: './thead-form.component.html',
  styleUrls: ['./thead-form.component.scss', './../program.component.scss']
})
export class TheadFormComponent {

}
